/**
 * Stock Transfer domain service.
 *
 * Wraps the trusted transfer RPCs (create/ship/receive/cancel). Moving stock
 * between locations is transactional and ledger-backed — always via the
 * backend, never assembled client-side.
 */

import { callRpc } from "@/lib/api/rpc";

export interface TransferLineInput {
  product_id: string;
  variant_id: string | null;
  qty: number;
}

export function createStockTransfer(params: {
  fromLocationId: string;
  toLocationId: string;
  lines: TransferLineInput[];
  idempotencyKey: string;
}): Promise<unknown> {
  return callRpc("create_stock_transfer", {
    p_from_location_id: params.fromLocationId,
    p_to_location_id: params.toLocationId,
    p_lines: params.lines,
    p_idempotency_key: params.idempotencyKey,
  });
}

export function shipStockTransfer(transferId: string): Promise<void> {
  return callRpc("ship_stock_transfer", { p_transfer_id: transferId });
}

export function receiveStockTransfer(transferId: string, lines: TransferLineInput[]): Promise<void> {
  return callRpc("receive_stock_transfer", { p_transfer_id: transferId, p_lines: lines });
}

export function cancelStockTransfer(transferId: string): Promise<void> {
  return callRpc("cancel_stock_transfer", { p_transfer_id: transferId });
}